/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { FaPlusCircle } from 'react-icons/fa';

import Product from '../Product';

import Cat from './styles';

class Category extends Component {
  render() {
    const {
      id, name, products, visible,
    } = this.props.item;

    return (
      <Cat visible={visible}>
        <div className="top">
          <h2>{name}</h2>
          <button type="button" onClick={() => this.props.editCategory(id, name, visible)}>Editar</button>
        </div>
        {products.length !== 0 ? (
          <div>
            <table className="table-lg">
              <thead>
                <tr className="head">
                  <th>Thumbnail</th>
                  <th>Nome</th>
                  <th>Codígo</th>
                  <th>Preço</th>
                  <th>Qtd.</th>
                  <th>Status</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {products.map(item => (
                  <Product
                    key={item.id}
                    id={item.id}
                    item={item}
                    editMaterial={this.props.editMaterial}
                  />
                ))}
              </tbody>
            </table>
            <div className="table-sm">
              {products.map(item => (
                <Product
                  key={item.id}
                  id={item.id}
                  item={item}
                  editMaterial={this.props.editMaterial}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="not-found">Nenhum material encontrado</div>
        )}
        <div className="footer">
          <button type="button" onClick={() => this.props.addMaterial(id, name)}>
            <FaPlusCircle className="fa fa-plus-circle" />
            <span>Adicionar material</span>
          </button>
        </div>
      </Cat>
    );
  }
}

export default Category;
